var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    _vm._l(_vm.getMissingInputs(), function (input) {
      return _vm.currentJob.apiJob?.warnings.length > 0
        ? _c("div", { staticClass: "file-item flex-column flex-md-row" }, [
            _c("div", { staticClass: "item d-inline-flex gap-10px" }, [
              _c("input", { attrs: { type: "checkbox", disabled: "" } }),
              _vm._v(" "),
              _vm._m(0, true),
              _vm._v(" "),
              _c("span", { staticClass: "short-text-name" }, [
                _vm._v(_vm._s(input.filename)),
              ]),
              _vm._v(" "),
              _c("span", { staticClass: "text-muted" }, [
                _vm._v(
                  "\n          " +
                    _vm._s(_vm.getReadableSize(input.size)) +
                    "\n        "
                ),
              ]),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "flex-grow-1 justify-content-end d-flex file-actions item align-items-center",
              },
              [
                _c("div", [
                  _c("div", { staticClass: "file-warning m-0" }, [
                    _c("strong", [
                      _vm._v(
                        _vm._s(_vm._f("trans")("Could not convert this file")) +
                          "\n          "
                      ),
                    ]),
                  ]),
                ]),
              ]
            ),
          ])
        : _vm._e()
    }),
    0
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "item hoverFileListItem" }, [
      _c("div", { staticClass: "thumb-small no-preview" }, [
        _c("i", { staticClass: "far fa-file" }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }